export default {
  driver_performance_cases_title: "Driver Performance - cases",
  driver_performance_cases_caseId: "Case ID",
  driver_performance_cases_created: "Created",
  driver_performance_cases_completed: "Completed",
  driver_performance_cases_eventCount: "Event Count",
  driver_performance_cases_driver: "Driver",
  driver_performance_cases_coach: "Coach",
  driver_performance_cases_asset: "Asset",
  driver_performance_cases_status: "Status",
  driver_performance_cases_tag: "Tag",
  driver_performance_cases_tags: "Tags",
  driver_performance_cases_custom: "Custom",
  driver_performance_cases_today: "Today",
  driver_performance_cases_yesterday: "Yesterday",
  driver_performance_cases_week: "This Week",
  driver_performance_cases_lastWeek: "Lask Week",
  driver_performance_cases_thisMonth: "This Month",
  driver_performance_cases_lastMonth: "Last Month",
  driver_performance_cases_quarter: "This Quarter",
  driver_performance_cases_lastQuarter: "Last Quarter",
  driver_performance_cases_assignCoach : "Re-Assign Coach",
  driver_performance_cases_nextStep : "Next Step / Result",
  dashboard_view: "View",
  driver_performance_cases_minutes : "Minutes",
  driver_performance_cases_noMoreItems: "You have no more pending coaching cases.",
  driver_performance_cases_status_pending: "Pending",
  driver_performance_cases_status_evaluate: "Evaluate",
  driver_performance_cases_status_completed: "Completed",
  driver_performance_cases_step_AssignCoach: 'Assign Coach',
  driver_performance_cases_step_InitiateCoaching: "Initiate Coaching",
  driver_performance_cases_step_Monitor: "Monitor",
  driver_performance_cases_step_PIOmited: "PI Omited",
  driver_performance_cases_step_PISuccessfull: "PI Successfull",
  driver_performance_cases_step_Judgement: "Judgement",
  driver_performance_cases_step_PIFailed: "PI Failed",
  driver_performance_cases_searchInput: "Search by Case ID",
  driver_performance_cases_coachUpdated: "Coach was updated successfully",
  driver_performance_cases_status_expired: "Expired",
  driver_performance_cases_step_Expired: "Expired",
};
